// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"232":"97eb6a45","243":"97eb6a45","414":"97eb6a45","797":"97eb6a45","926":"97eb6a45","960":"97eb6a45"}[chunkId] + ".chunk.css";
};